export const viewHeightCalc = (px) => {
    return `${(px * 100) / 1024}vh`;
};

export const viewWidthCalc = (px) => {
    return `${(px * 100) / 1440}vw`;
};
